/**
 * Chart.js 树摇模式下须在首屏前统一注册；避免各页面分散 register 导致「category is not a registered scale」。
 */
import {
	ArcElement,
	BarController,
	BarElement,
	CategoryScale,
	Chart as ChartJS,
	Legend,
	LinearScale,
	PieController,
	Tooltip,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(CategoryScale, LinearScale, ArcElement, BarElement, BarController, PieController, Tooltip, Legend, ChartDataLabels);
